"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spaceMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
var _addSuffix = require("../util/addSuffix");
/** @mixin spaceMixin */
/**
 * Returns the spacing value.
 *
 * @example
 * import { spaceMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     margin-top: ${spaceMixin('sm')};
 *     margin-bottom: ${spaceMixin('sm', space => space.value * 2 + space.suffix)};
 * `;
 *
 * @method
 * @param {string|number} spacing - The spacing t-shirt size or number multiplier.
 * @param {function} [callback] - A callback that can be used to modify the resulting value.
 *    The callback receives an object with values `value` and `suffix`, where `value` is the numeric
 *    value of the spacing, and `suffix` is the value type (e.g. "px").
 * @return {Interpolation}
 */
var spaceMixin = function spaceMixin(space, callback) {
  return (0, _styledToken.default)({
    gridBase: 'gridBase',
    spacing: 'spacing',
    suffix: 'defaultUnit'
  }, function (_ref) {
    var gridBase = _ref.gridBase,
      spacing = _ref.spacing,
      suffix = _ref.suffix;
    var value = 0;
    if (spacing) {
      if (space in spacing) {
        value = spacing[space];
      } else {
        var multiplier = Number(space);
        if (Number.isNaN(multiplier)) {
          multiplier = 0;
        }
        value = (gridBase || 0) * multiplier;
      }
    }
    if (typeof callback === 'function') {
      return callback({
        value: value,
        suffix: suffix
      });
    }
    return (0, _addSuffix.addSuffix)(value, suffix);
  });
};
exports.spaceMixin = spaceMixin;